import { render, staticRenderFns } from "./cardHeader.vue?vue&type=template&id=fa260f0c&"
import script from "./cardHeader.vue?vue&type=script&lang=js&"
export * from "./cardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports